import {useClickAnalytics} from '@github-ui/use-analytics'
import {type SelectPanelItemInput, Token} from '@primer/react'
import {clsx} from 'clsx'

import styles from '../UserStatusDialog.module.css'
import {Emoji, type EmojiAttributes} from './Emoji'

export interface Suggestion {
  message: string
  emojiAttributes: EmojiAttributes
}

export interface SuggestionChipsProps {
  suggestions: Suggestion[]
  updateInputs: (inputs: {emoji?: EmojiAttributes; message: string}) => void
  inputValue: string
  emojiValue?: SelectPanelItemInput
  tone: number
}
const defaultCategory = 'USER_STATUS_DIALOG'

const SuggestionChips = (props: SuggestionChipsProps) => {
  const {updateInputs, suggestions, inputValue, emojiValue, tone} = props
  const {sendClickAnalyticsEvent} = useClickAnalytics()

  return (
    <div className={styles.suggestionChipsContainer}>
      {suggestions.map(suggestion => {
        const classes = clsx(suggestion.emojiAttributes.attributes.class, styles.suggestionChipEmoji)
        return (
          <Token
            key={suggestion.message}
            className={styles.suggestionChip}
            as="button"
            type="button"
            aria-pressed={inputValue === suggestion.message && emojiValue?.id === suggestion.emojiAttributes.name}
            onClick={() => {
              sendClickAnalyticsEvent({
                category: defaultCategory,
                action: 'SET_SUGGESTED_USER_STATUS',
                label: suggestion.message,
              })
              updateInputs({emoji: suggestion.emojiAttributes, message: suggestion.message})
            }}
            leadingVisual={() => (
              <Emoji
                {...suggestion.emojiAttributes}
                attributes={{...suggestion.emojiAttributes.attributes, class: classes}}
                tone={tone}
              />
            )}
            text={suggestion.message}
          />
        )
      })}
    </div>
  )
}

export default SuggestionChips

try{ SuggestionChips.displayName ||= 'SuggestionChips' } catch {}